import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import LocationSidebar from "../components/LocationSidebar";

const bg = require("../../../../images/servicehero.png");

class DeepCleaningBrisbane extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Deep Cleaning Brisbane | Professional Home & Office Cleaning"
          description="Deep cleaning Brisbane services. Thorough sanitisation for homes, apartments and offices."
          keywords="deep cleaning brisbane, house deep cleaning brisbane, office deep cleaning brisbane, professional sanitisation brisbane, residential deep cleaning brisbane, commercial deep cleaning brisbane, intensive cleaning brisbane, thorough house clean brisbane, spring cleaning brisbane, renovation cleaning brisbane, after builders cleaning brisbane, event cleaning brisbane, holiday house cleaning brisbane, deep home sanitisation brisbane, expert deep cleaners brisbane, best deep cleaning company brisbane, reliable house cleaners brisbane, sanitising services brisbane, high reach cleaning brisbane, detailed property cleaning brisbane, deep apartment cleaning brisbane, medical grade cleaning brisbane, allergen deep cleaning brisbane, steam cleaning services brisbane, kitchen deep cleaning brisbane, bathroom deep cleaning brisbane, floor deep cleaning brisbane, wall cleaning brisbane, ceiling fan cleaning brisbane, window track cleaning brisbane"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Deep Cleaning Services Brisbane</h1>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <LocationSidebar activePage="/deep-cleaning-brisbane/" />
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Deep Cleaning Services Brisbane
                          </h4>
                          <p>
                            Our deep cleaning Brisbane service provides
                            comprehensive cleaning beyond routine maintenance.
                          </p>
                          <h4 className="dlab-title m-t30">Ideal for:</h4>
                          <ul className="list-check primary">
                            <li>Seasonal cleaning</li>
                            <li>After renovations</li>
                            <li>Before special events</li>
                            <li>Long-overdue cleaning</li>
                          </ul>
                          <p>
                            We clean all surfaces, hidden areas and high-touch
                            points to ensure maximum hygiene. Our professional
                            team uses advanced equipment and eco-friendly
                            solutions to deliver a truly deep clean for your
                            home or office in Brisbane.
                          </p>

                          <h4 className="dlab-title m-t30">
                            The Kangaroo Shine Difference
                          </h4>
                          <p>
                            Unlike a regular maintenance clean, our deep
                            cleaning service focuses on removing built-up grime,
                            dust, and bacteria from every corner of your
                            property. We pay special attention to areas like
                            skirting boards, light switches, door frames, and
                            behind appliances to ensure your space is completely
                            revitalized.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default DeepCleaningBrisbane;
